// Client-side config - uses Vite's import.meta.env
// Only VITE_ prefixed environment variables are exposed to the client
// This file is safe to import in browser code

export const VITE_GOOGLE_PLACES_API_KEY = 
  (typeof import.meta !== 'undefined' && import.meta.env?.VITE_GOOGLE_PLACES_API_KEY) || ''

export const VITE_PREFILL_PHONE = 
  (typeof import.meta !== 'undefined' && import.meta.env?.VITE_PREFILL_PHONE) || ''
